<div class="wrapper">
      <div id="comparisonChartContainer" class="mt-20px" style="width: 100%; height: 400px"></div>
</div>